export default "__VITE_ASSET__c2d6deb5__"